export const MEDICAL_BRAND_CODES = ['307AM', '307AMS', '307JBM'];
